import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ResetPasswordPage } from '@/pages/reset-password';

const resetPasswordSearchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute('/_public/reset-password')({
  validateSearch: resetPasswordSearchSchema,
  component: ResetPasswordPage,
});
